import React from 'react';

const HtmlContent = ({ content, className = '', maxLength = null }) => {
  if (!content) return null;

  // Если указана максимальная длина, обрезаем контент
  let displayContent = content;
  if (maxLength && content.length > maxLength) {
    // Создаем временный элемент для извлечения текста
    const tmp = document.createElement('div');
    tmp.innerHTML = content;
    const textContent = tmp.textContent || tmp.innerText || '';
    
    if (textContent.length > maxLength) {
      displayContent = textContent.substring(0, maxLength) + '...';
      return (
        <span className={className} title={textContent}>
          {displayContent}
        </span>
      );
    }
  }

  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: displayContent }}
    />
  );
};

export default HtmlContent; 